export const config = {
  server: {
    get baseUrl() {
      // When running locally with proxy to remote staging, use relative URLs
      // so requests go through webpack-dev-server proxy
      if (
        typeof window !== 'undefined' &&
        window.location.hostname === 'localhost' &&
        (process.env.NX_REACT_APP_BASE_PATH || '').startsWith('https://')
      ) {
        return '';
      }
      return process.env.NX_REACT_APP_BASE_PATH || '';
    }
  },
  dataDog: {
    applicationId: process.env.NX_DD_APPLICATION_ID,
    clientToken: process.env.NX_DD_CLIENT_TOKEN,
    site: process.env.NX_DD_SITE,
    defaultPrivacyLevel: process.env.NX_DD_PRIVACY_LEVEL,
    service: process.env.NX_DD_SERVICE
  },
  appEnv: process.env.NX_REACT_APP_ENV,
  appEnvType: process.env.NX_REACT_APP_ENV_TYPE,
  isLocalMode: process.env.NX_REACT_APP_ENV === 'local',
  isStagingMode: process.env.NX_REACT_APP_ENV === 'staging01',
  google: {
    clientId: process.env.NX_REACT_APP_GOOGLE_CLIENT_ID,
    clientIdXero: process.env.NX_REACT_APP_GOOGLE_CLIENT_ID_XERO
  },
  slack: process.env.NX_REACT_APP_SLACK_CHANNEL,
  slackSubscription: process.env.NX_REACT_APP_SLACK_SUBSCRIPTION_CHANNEL,
  surveyjsLicense: process.env.NX_REACT_APP_SURVEY_CREATOR_LICENSE,
  zendesk: {
    baseUrl: process.env.NX_ZENDESK_BASE_PATH
  },
  auth: {
    enableBypassLogin: process.env.NX_ENABLE_BYPASS_LOGIN === 'true',
    testUserAgent: process.env.NX_BYPASS_LOGIN_USER_AGENT
  }
};
